<template>
  <zt-modal
    :active="isActiveModalError"
    :title="$t('message.publishDocuments.modals.error.title')"
    @close="closeDialog"
    max-width="600px"
  >
    <template>
      <div class="flex items-center px-10 py-16">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem' }"
          />
        </div>
        <div>
          <p class="text-zt-lg">
            {{ errorModalStore.error.message }}
          </p>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-center lg:justify-end items-center p-4"
      >
        <zt-button
          data-vs-button="go-detail"
          @click="closeDialog"
        >
          {{ $t('message.publishDocuments.modals.error.ok') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'ModalNotificationError',
  inject: [
    'errorModalStore',
    'setActiveErrorModal'
  ],
  props: {
    isActiveModalError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.setActiveErrorModal(false)
    },
    redirectTo() {
      this.closeDialog()
    }
  }
}
</script>

<style scoped>
.warning-icon {
  color: #fb8c00;
}
.warning-icon i {
  font-size: 4rem;
}
.zt-modal-footer {
  background-color: #eee;
}
::v-deep .zt-button.text-primary-200 {
  color: #4f41a3 !important;
  background-color: #eee;
}
::v-deep .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
</style>